// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__KaZzt","subContainer":"NotFound_subContainer__ALHXj"};